import React, { Component, Fragment } from "react";
import Header from './Header';
import Footer from './Footer';
import { injectStripe } from 'react-stripe-elements';
import { connect } from "react-redux";
import { signUpAgencyUser } from "../store/actions/auth";
import { showAlert } from '../store/actions/alert';
import { fetchReferralDetail } from '../store/actions/brand'
import Card from '../modals/card'
import { APP_LINK } from '../constants';

class EnrollAgency extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isFetchResponse: false,
      isSuccessResponse: false,
      isValidPage: true,
      isSubmit: false,
      partnerImg: '',
    };
 }

  componentDidMount() {
  }

  showSuccessMessage = (isUserExist) => {
    this.setState({
      isFetchResponse: true,
      isSuccessResponse: true,
    });
  }

  
  handleSubmit = e => {
    e.preventDefault();
  };

  
  renderPartnerImage() {
		return (<img src="/assets/img/agency-enroll.jpg" width="400px" alt="Thumb" />)
	}

  render() {

    const { isSubmit, planName } = this.state;

    const { isNCEP } = this.props;

    const borderStyle = '2px solid #e95e00';

    return (
      <Fragment>
        <Header {...this.props} />
        
        {!this.state.isFetchResponse && !this.state.isSuccessResponse && !this.state.isFetchResponse &&
          <div style={{ 'paddingBottom': '30px' }} id="overview" className="work-list-area default-padding">
              <div className="container">
                <div className="row">
                  <div className="col-md-6 thumb text-center">
                     {this.renderPartnerImage()}
                  </div>
                  <div className="col-md-6 info follow-me-top text-center">
                    <h3>
                      { isNCEP ?
                       'As a NCEP certified personal trainer, you will have exclusive rights to register for your own branded training app for FREE':
                       'Register today for your own branded app for only $49 per month'
                     }.</h3>
                    <a style={{ 'marginTop': '20px', 'marginBottom': '20px' }}
                      className="btn circle btn-light border btn-md" data-toggle="modal"
                      data-target={'#enrollTrainer'}>
                      {  isNCEP ?
                        'Register now for FREE' :
                        'Register now'
                     }</a>
                  </div>
                </div>
              </div>
          </div>
        }
        {
          this.state.isFetchResponse && this.state.isSuccessResponse && 
          <div style={{ 'paddingBottom': '30px' }} id="overview" className="work-list-area default-padding scenaro-1">
            <div className="container">
              <div className="row">
                <div className="col-md-12 info follow-me-top text-center">
                  <p style={{ 'fontSize': '20px', 'fontWeight': 'bold' }}>
                    { isNCEP ?
                    'Thank you for registering for your very own training app as a NCEP trainer!'
                      : 'Thank you for registering for your very own training app!'
                    }
                   
</p>
                  <div style={{'marginBottom': '30px'}}>
                    <span style={{ 'fontSize': '20px', 'fontWeight': 'bold' }}>Next steps:</span>
                    <div>
                      <div>Download the FITBANX app from the app stores and use the same email address and password you just created to log in.</div>
                       <div>Check your email inbox for instructions on how to easily set up and start using your very own branded training app! </div>
                    </div> 
                    <div style={{'marginTop': '20px'}}>Please email <a href="mailto:support@fitbanx.com">support@fitbanx.com</a> for any questions or concerns.</div>  
                  
                    </div>
                </div>
                <div className="col-md-12" style={{ 
										width: '555px',
										textAlign: 'center',
										margin: '20px auto',
										float: 'none'
									 }}>
										<div className="col-md-6">
											<a href={APP_LINK.IOS} target="_blank">
												<img src="/assets/img/app-store.png" alt="app-store" />
											</a>
										</div>
										<div className="col-md-6">
											<a href={APP_LINK.ANDROID} target="_blank">   
												<img
													src="/assets/img/play-store.png"
													alt="play-store"
												/>
											</a>
										</div>
										<div className="col-md-12">
											<h5 style={{ marginTop: '20px', fontSize: '60px' }}>
												<em>Free Download</em>
											</h5>
										</div>
									</div>
                <div className="col-md-12 col-sm-12 equal-height item">
                  <div className="text-center">
                    <img style={{ 'margin': '50px auto' }} src="/assets/img/logo.png" width="300" alt="logo" />
                  </div>
                </div>
              </div>
            </div>  
          </div>

        }
        <Footer {...this.props} planName={planName} isNCEP={isNCEP} openPaymentForm={this.openPaymentForm} showSuccessMessage={this.showSuccessMessage} />
      </Fragment>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    signUpAgencyUser: (data) => {
      return dispatch(signUpAgencyUser(data));
    },
    showAlert: (message, isError) => {
      return dispatch(showAlert(message, isError));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EnrollAgency);



// WEBPACK FOOTER //
// ./src/components/EnrollAgency.js